module.exports = __webpack_public_path__ + "img/banner-hora-facil.7b0854b4.png";